@import 'styles/mixins';

.header {
  padding-top: 30px;
  padding-left: 10px;

  [data-autopilot-system-redesign='on'] & {
    background-color: transparent;
    padding-left: 12px;
    border-bottom: none;
  }
}

.subHeader {
  @include for-desktop-only {
    padding-left: 8px;
    padding-bottom: 8px;
  }
}
